// Only semantic scalars are transported. Never copy rows or chart datasets.
export const boundedVisibleDataContext = (source) => {
  if (!source || typeof source !== "object" || Array.isArray(source)) return undefined;
  const result = {};
  const text = (target, key, value) => {
    if (typeof value === "string" && value.trim()) target[key] = value.trim().slice(0, 200);
  };
  for (const key of ["source_label", "metric_label", "unit", "chart_type"]) text(result, key, source[key]);
  for (const [group, keys] of Object.entries({
    visible_range: ["start", "end"],
    summary: ["total", "average", "median", "minimum", "maximum", "maximum_at", "minimum_at", "sample_count"],
    quality: ["coverage", "missing_samples"],
  })) {
    const values = {};
    for (const key of keys) {
      const value = source[group]?.[key];
      if (group === "visible_range" || key.endsWith("_at")) text(values, key, value);
      else if (typeof value === "number" && Number.isFinite(value)) values[key] = value;
    }
    if (Object.keys(values).length) result[group] = values;
  }
  // Other modules can publish a few labelled values without an arbitrary JSON bag.
  if (Array.isArray(source.facts)) result.facts = source.facts.slice(0, 8).flatMap((fact) => {
    const item = {};
    text(item, "label", fact?.label);
    text(item, "unit", fact?.unit);
    if (typeof fact?.value === "number" && Number.isFinite(fact.value)) item.value = fact.value;
    else text(item, "value", fact?.value);
    return item.label && item.value !== undefined ? [item] : [];
  });
  return new TextEncoder().encode(JSON.stringify(result)).length <= 6000 ? result : undefined;
};
